import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Form, Input, Row, Col } from "antd";

const Step5Summary = () => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    return (
        <div style={{ background: "#fff", padding: 25, borderRadius: 8 }}>
            <Form layout="vertical">

                {/* -------------- LOGIN CREDENTIAL SECTION -------------- */}
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>
                    Login Credential
                </h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            label={<span><span style={{ color: "red" }}>*</span> Office Email</span>}
                            validateStatus={errors.loginOfficeEmail ? "error" : ""}
                            help={errors.loginOfficeEmail?.message}
                        >
                            <Controller
                                name="loginOfficeEmail"
                                control={control}
                                rules={{
                                    required: "Office email is required",
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Enter a valid email address",
                                    },
                                }}
                                render={({ field }) => (
                                    <Input
                                        placeholder="Enter email"
                                        type="email"
                                        {...field}
                                    />
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label={<span><span style={{ color: "red" }}>*</span> Password</span>}
                            validateStatus={errors.loginPassword ? "error" : ""}
                            help={errors.loginPassword?.message}
                        >
                            <Controller
                                name="loginPassword"
                                control={control}
                                rules={{
                                    required: "Password is required",
                                    minLength: {
                                        value: 8,
                                        message: "Password must be at least 8 characters",
                                    },
                                }}
                                render={({ field }) => (
                                    <Input.Password
                                        placeholder="Enter password"
                                        {...field}
                                    />
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>

            </Form>
        </div>
    );
};

export default Step5Summary;
